import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalizedUnderscore'
})

export class NormalizedUnderscorePipe implements PipeTransform {

  transform(name: string): string {
    const label = name.replace(/_/g, ' ');
    return label.charAt(0).toUpperCase() + label.slice(1);
  }

}
